export const withTimeout = <T>(promise: Promise<T>, timeoutMs: number, message: string): Promise<T> =>
    new Promise<T>((resolve, reject) => {
        const timeout = globalThis.setTimeout(() => reject(new Error(message)), timeoutMs);

        promise.then(
            (value) => {
                globalThis.clearTimeout(timeout);
                resolve(value);
            },
            (error) => {
                globalThis.clearTimeout(timeout);
                reject(error);
            }
        );
    });
